
import { useEffect, useState } from 'react';
import { Outlet} from 'react-router-dom';
import useActiveItem from 'hooks/useActiveItem';
import { marketplaceTabs } from 'consts/tabs';
import 'assets/css/marketplace.css'
import useFiltersData from 'hooks/useFiltersData';
import usePageItems from 'hooks/usePageItems';
import useFiltersQueryParams from 'hooks/useFiltersQueryParams';
import PageBlockLogin from 'components/page-components/PageBlockLogin';
import GradientBlock from 'components/GradientBlock';
import MainSort from 'components/main-components/MainSort';
import MainTabs from 'components/main-components/MainTabs';
import useProfile from 'hooks/useProfile';
import Cookies from 'js-cookie';

const MarketPlaceRoute = () => {
  const {isActiveItem} = useActiveItem();
  const { searchParams, setQueryParam } = useFiltersQueryParams();
  const [currentSort, setCurrentSort] = useState({ label: 'A-Z', order: 'a_z' });
  const [isFiltersLoading, setIsFiltersLoading] = useState(false);
  const [isItemsLoading, setIsItemsLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0);
  const { isLogged } = useProfile();
  const token = Cookies.get('token');

  const getOpenedClass = () => {
    if (
      filters ||
      (Array.isArray(items) && items.length > 0) ||
      isActiveItem
    ) {
      return 'opened';
    } else if (!filters && Array.isArray(items) && items.length < 1) {
      return ''
    }
  };

  const outletProps = {
    isFiltersLoading,
    isItemsLoading,
    items,
    filters,
    paginationData,
    offsetCount,
    setOffsetCount,
    getOpenedClass,
    setQueryParam
  };

  useFiltersData(setFilters, setIsFiltersLoading);
  usePageItems(setItems, setPaginationData, offsetCount, setIsItemsLoading, currentSort.order);

  useEffect(() => {
    setOffsetCount(0);
  }, [searchParams]);

  return (
    <>
      <GradientBlock additionalClassName='gradient-block--lightblue'>
        <MainTabs tabs={marketplaceTabs} />
        <MainSort currentSort={currentSort} setCurrentSort={setCurrentSort} setOffsetCount={setOffsetCount} />
      </GradientBlock>
      {!token && !isLogged ? <PageBlockLogin /> : <Outlet context={outletProps} />}
    </>
  )
}

export default MarketPlaceRoute;
